import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { environment } from "@env";
import { KeycloakService } from "keycloak-angular";

@Component({
  selector: "app-risk-score-authoring",
  templateUrl: "./risk-score-authoring.component.html",
  styleUrls: ["./risk-score-authoring.component.scss"],
})
export class RiskScoreAuthoringComponent implements OnInit {
  public assetSourceTooltipContent: string = `An Asset Source Id is a unique identifier that helps track the origin of an asset. 
  <a href="https://assetsource.com" target="_blank">Learn more</a>`;

  public pages: Array<string> = ["Ruleset", "Rules"];

  public selectedPage: string = null;

  constructor(
    private router: Router,
    private keycloakservice: KeycloakService
  ) {}

  ngOnInit(): void {}

  go() {
    if (this.selectedPage === "Ruleset") {
      this.router.navigate(["ada-access/auth-tools/policy-authoring/ruleset/search"]);
    } else if (this.selectedPage === "Rules") {
      this.router.navigate(["ada-access/auth-tools/policy-authoring/rules/search"]);
    }
  }
  
  back() {
    this.router.navigate(["ada-access/auth-tools/"]);
  }

  public resetPage() {
    this.selectedPage = null;
  }

  logout(): void {
    this.keycloakservice.logout( environment.keyCloakRedirectUrl);
  }
}
